import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "@/components/common/Image";
import Icon from "@/components/icon/Icon";
import { BRAND_PRODUCTS_PAGE } from "@/settings/constant";
import { Box, Stack, styled, Typography } from "@mui/material";
import { Sizes, Success24Fill } from "../icon/IconList";
import { useBrandStore } from "./BrandProvider";
import { CountLink } from "./CountLink";
import { useBrandQuery } from "./queries/useBrandQuery";
import { ShareButton } from "./ShareButton";
import { SubscribeButton } from "./SubscribeButton";
export const AuthorProfile = ()=>{
    const { name , productCount , profileImageUrl , nickname , keyword  } = useBrandStore((state)=>state.brand);
    const { data: brand  } = useBrandQuery({
        name
    });
    const subscriberCount = brand === null || brand === void 0 ? void 0 : brand.subscriberCount;
    return /*#__PURE__*/ _jsxs(BrandProfileContainer, {
        children: [
            /*#__PURE__*/ _jsx(ProfileImage, {
                width: 128,
                height: 128,
                src: profileImageUrl,
                alt: "profile",
                defaultImage: "/static/images/profile_image_empty.png"
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                alignItems: "flex-start",
                gap: "12px",
                sx: {
                    textAlign: "left"
                },
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h5",
                        color: "text-title",
                        children: nickname
                    }),
                    keyword && /*#__PURE__*/ _jsxs(Description, {
                        children: [
                            /*#__PURE__*/ _jsx(Icon, {
                                icon: Success24Fill,
                                size: Sizes.small
                            }),
                            keyword
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Stack, {
                        direction: "row",
                        gap: "12px",
                        children: [
                            /*#__PURE__*/ _jsx(CountLink, {
                                label: "상품 수",
                                count: productCount,
                                href: BRAND_PRODUCTS_PAGE(name)
                            }),
                            /*#__PURE__*/ _jsx(CountLink, {
                                label: "구독자 수",
                                count: subscriberCount
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Box, {
                        gap: "8px",
                        display: "flex",
                        children: [
                            /*#__PURE__*/ _jsx(SubscribeButton, {}),
                            /*#__PURE__*/ _jsx(ShareButton, {})
                        ]
                    })
                ]
            })
        ]
    });
};
const BrandProfileContainer = styled("div")((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        gap: "20px",
        marginBottom: "40px",
        [theme.breakpoints.down("lg")]: {
            marginBottom: "32px"
        },
        [theme.breakpoints.down("sm")]: {
            gap: "16px",
            marginBottom: "28px",
            padding: "0 20px"
        }
    };
});
const ProfileImage = styled(Image)((param)=>{
    let { theme  } = param;
    return {
        width: 128,
        height: 128,
        borderRadius: "50%",
        border: "1px solid rgba(169, 175, 199, 0.20)",
        objectFit: "contain",
        maxWidth: "100%",
        maxHeight: "100%",
        [theme.breakpoints.down("sm")]: {
            width: 80,
            height: 80
        }
    };
});
const Description = styled(Typography)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        alignItems: "start",
        gap: "4px",
        color: theme.palette.primary.main,
        ...theme.typography.subtitle1,
        i: {
            paddingTop: "2px"
        },
        [theme.breakpoints.down("sm")]: {
            ...theme.typography.subtitle2
        }
    };
});
